import { render, staticRenderFns } from "./CalllogList.vue?vue&type=template&id=1a2df495&scoped=true&"
import script from "./CalllogList.vue?vue&type=script&lang=ts&"
export * from "./CalllogList.vue?vue&type=script&lang=ts&"
import style0 from "./CalllogList.vue?vue&type=style&index=0&id=1a2df495&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2df495",
  null
  
)

export default component.exports